
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCloudyColour as ObiCloudyColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cloudy-colour.js';
 
 
 

 
 export const ObiCloudyColour = createComponent({
   react: React,
   tagName: 'obi-cloudy-colour',
   elementClass: ObiCloudyColourElement,
   events: {
     
   }
  });
 
 